import React from 'react';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';

import ArticleHeading from './src/components/ArticleHeading';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'article-heading',
        component: ArticleHeading,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
